import { render } from "./FacebookReelReview.vue?vue&type=template&id=35d7ba48"
import script from "./FacebookReelReview.vue?vue&type=script&lang=js"
export * from "./FacebookReelReview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__